<template>
  <div class="wrap">
    <Header :class="`${'fixedHeader'}`" />
    <div class="banner">
      <!-- <img src="../../assets/image/useCases/useBanner.png" alt="" /> -->
      <img v-lazy="imgObj" alt="" />
    </div>
    <div class="main">
      <!-- 第一 -->
      <div class="first" ref="container">
        <div class="content">
          <div class="titleBg">
            <h2>{{ $t("OurServices") }}</h2>
            <!-- <h2>Our Services</h2> -->
          </div>
          <p>{{ $t("contentP") }}</p>
          <!-- <p>
            Seeder is continuously developing credit scoring and customer
            profiling service. You can subscribe this through Seeder.
          </p> -->
        </div>
        <div class="content">
          <div class="titleBg">
            <h2>{{ $t("ServiceTypes") }}</h2>
            <!-- <h2>Service Types</h2> -->
          </div>
          <h4>{{$t("CreditScoreDevelopment")}}</h4>
          <p>{{ $t("contentP2") }}</p>
          <!-- <h4>Credit Score Development</h4> -->
          <!-- <p>
            Developing credit scoring system with a strong foundation of credit
            history and alternative data to better measure the risks of your
            customers.
          </p> -->
          <h4>{{$t("SubscribeourscoringAPlviaSeeder")}}</h4>
          <p>{{ $t("contentP3") }}</p>
          <!-- <h4>Subscribe our scoring APl via Seeder</h4>
          <p>
            Seeder is user management system, enabling user to easily subscribe
            to API products.
          </p> -->
        </div>
        <div class="content">
          <div class="titleBg">
            <h2>{{ $t("CreditScore") }}</h2>
            <!-- <h2>Credit Score Development</h2> -->
          </div>
          <h4>{{$t("DeepLearning")}}</h4>
          <!-- <h4>
            Deep Learning, Machine Learning Techniques Big Data for Predictive
            Credit Score
          </h4> -->
          <img
            v-if="launage === 'en_US'"
            style="width: 100%; margin-top: 16px"
            src="../../assets/image/q1.jpg"
            alt
          />
          <img
            v-if="launage === 'id'"
            style="width: 100%; margin-top: 16px"
            src="../../assets/idImage/q2.jpg"
            alt
          />
          <p>{{ $t("DeepLearningContent") }}</p>
          <p>{{ $t("Wecontinuously") }}</p>
          <!-- <p>
            Our credit scoring system combines the conventional credit history
            and alternative data to have a 360 customer's view to accurately
            predict the risk profile of an incoming loan application.
          </p>
          <p>
            We continuously improve and add more relevant scores from our
            exploration and development cycles by refining each step: capturing
            data, update model, and measure.
          </p> -->
        </div>
        <div class="content">
          <div class="titleBg">
            <h2>{{ $t("AlternativeData") }}</h2>
            <!-- <h2>Alternative Data for Better Financial Decision</h2> -->
          </div>
          <p>{{ $t("Ourdatalayer") }}</p>
          <!-- <p>
            Our data layer engine helps financial institutions and business
            partners to leverage alternative data, with the user's consent, for
            making credit decisions.
          </p> -->
          <div class="box">
            <div class="left">
              <p>
                <img src="../../assets/idImage/icon1.png" alt="" />
                <span>{{ $t("xinyongtext1") }}</span>
                <!-- <span>Financial lnstitutions</span> -->
              </p>
              <p>
                <img src="../../assets/idImage/icon2.png" alt="" />
                <span>{{ $t("xinyongtext2") }}</span>
                <!-- <span>E-Wallet</span> -->
              </p>
              <p>
                <img src="../../assets/idImage/icon3.png" alt="" />
                <span>{{ $t("xinyongtext3") }}</span>
                <!-- <span>E-Commerce</span> -->
              </p>
            </div>
            <div class="right">
              <p>
                <img src="../../assets/idImage/icon4.png" alt="" />
                <span>{{ $t("xinyongtext4") }}</span>
                <!-- <span>Ride Hailing</span> -->
              </p>
              <p>
                <img src="../../assets/idImage/icon5.png" alt="" />
                <span>{{ $t("xinyongtext5") }}</span>
                <!-- <span>Online Travel Agent And many more...</span> -->
              </p>
              <p>
                <img style="width:60px" src="../../assets/idImage/icon6.jpg" alt="" />
                <span>{{ $t("xinyongtext6") }}</span>
                <!-- <span>Online Travel Agent And many more...</span> -->
              </p>
            </div>
          </div>
          <p>{{ $t("Thesedatawill") }}</p>
          <!-- <p>
            These data will then be used as one of the creditworthiness
            measurements. Credit worthiness is based on financial health, credit
            discipline, identity, behavior & preferences and social
            relationships.
          </p> -->
        </div>
        <div class="btn">
          <a href="/d394e76b-32eb-4707-bf30-42d84e5c60f5.pdf" download=""
            >{{ $t("Download") }}</a
          >
          <!-- <a href="/d394e76b-32eb-4707-bf30-42d84e5c60f5.pdf" download=""
            >Download</a
          > -->
          <!-- vue将文件放置 public 文件夹下 download="文件名.pdf"-->
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default {
  name: "UseCases",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      launage: "",
      fixedHeader: false,
      // imgObj: {
      //   preLoad: 1,
      //   loading:require("../../assets/image/useCases/use-loading.jpg"),
      //   src: require("../../assets/image/useCases/useBanner.png"),
      //   error: require("../../assets/image/error.jpg"),
      // },
    };
  },
  computed: {
    imgObj() {
      if (this.launage === "en_US") {
        return {
          preLoad: 1,
          loading: require("../../assets/image/score-loading.png"),
          src: require("../../assets/image/scoreBanner.png"),
          error: require("../../assets/image/error.jpg"),
        };
      } else {
        return {
          preLoad: 1,
          loading: require("../../assets/idImage/compress_cn/score-loading.png"),
          src: require("../../assets/idImage/scoreBanner.png"),
          error: require("../../assets/image/error.jpg"),
        };
      }
    },
  },
  created() {
    this.launage = this.$i18n.locale;
    //获取滚动条高度处理头部导航
    window.onscroll = () => {
      // console.log(e)
      this.fixedHeader = document.documentElement.scrollTop >= 60;
    };
  },
};
</script>
<style lang="less" scoped>
.wrap {
  width: 100%;
  .fixedHeader {
    position: fixed;
    background: black;
  }
  .absolute {
    position: absolute;
  }
}
.banner {
  width: 100%;
  min-height: 400px;
  img {
    display: block;
    width: 100%;
  }
}
.titleBg {
  // width: 30%;
  height: 50px;
  line-height: 50px;
  padding-left: 10px;
  background: #1A3362;
  color: #fff;
}
.main {
  //第一
  .first {
    background: #fff;
    width: 62%;
    margin: auto;
    padding-top: 66px;
    margin-bottom: 90px;
    h4 {
      margin-top: 26px;
      font-size: 20px;
      font-family: MicrosoftYaHei-Bold;
      font-weight: bold;
      color: #000000;
      text-align: center;
    }
    .content {
      margin-bottom: 54px;
      p {
        font-size: 18px;
        line-height: 1.6;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #071531;
        margin-top: 20px;
      }
      .box {
        display: flex;
        justify-content: space-between;
        img {
          vertical-align: middle;
          display: inline-block;
        }
        span {
          vertical-align: middle;
          padding-left: 10px;
        }
      }
    }
    .btn {
      width: 236px;
      height: 36px;
      background: #1A3362;
      text-align: center;
      line-height: 36px;
      // border-radius: 20px;
      a {
        color: #fff;
        text-decoration: none;
      }
    }
  }
}
</style>